import { useI18nStore } from '../../shared/i18n/i18nStore';

/**
 * The one line a guest gets under a participant / winner list: everyone else on
 * it is real and visible, the only thing missing is *you*. The button says what
 * signing up actually yields — tickets, not a seat in this draw — because a new
 * account holds no ticket until it earns one (PM decision 2026-09-14).
 */
export function GuestJoinFooter({ onSignup }: { onSignup: () => void }) {
  const t = useI18nStore((state) => state.t);
  return (
    <div className="srt-guest-join">
      <p>{t('sorteiosGuestListFooter')}</p>
      <button className="primary-button" type="button" onClick={onSignup}>
        {t('sorteiosGuestCta')}
      </button>
    </div>
  );
}
